export const numberFormat = (value) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(value);

export const numberPerCentageFormat = (value) =>
    new Intl.NumberFormat({
        floatValue: value | undefined,
        formattedValue: value,
        value: value
    }).format(value ? value.toFixed(2) : 0.00);

export const numberDecimalFormat = (value) =>
    new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(value);

export const numberShortFormat = (value) => {
    if (value >= 1000000) {
        return '$' + (value / 1000000).toFixed(2) + 'M';
    } else if (value >= 1000) {
        return '$' + (value / 1000).toFixed(2) + 'K';
    }
    return '$' + value.toFixed(2);
};
// export interface NumberFormatValues {
// floatValue: number | undefined;
// formattedValue: string;
// value: string;
// }
